import { render, staticRenderFns } from "./InspirationCard.vue?vue&type=template&id=0faf09aa"
import script from "./InspirationCard.vue?vue&type=script&lang=js"
export * from "./InspirationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports